<template>
  <div class="card" :class="cardClass">
    <div class="card-body">
      <div class="float-end">
        <div class="text-uppercase fw-semibold mt-1" :class="{'text-muted':$_utils.isEmpty(cardBg)}">{{ title }}</div>
        <h4 class="text-main-green mb-0 mt-2">
          <template v-if="!$_utils.isEmpty(valueTime)">
            {{ valueTime }}
          </template>
          <template v-else>
            <countTo :startVal="0" :endVal="endVal" :duration="1000" />
            <span class="text-deep-green">{{ valueTitle }}</span>
          </template>
        </h4>
      </div>
      <div class="avatar-xs">
        <span class="avatar-title rounded-circle bg-light font-size-20">
          <i :class="`mdi ${iconImage} text-${iconColor}`" />
        </span>
      </div>
      <div class="mt-2">
        <template v-if="compared > 0">
          <span class="badge badge-soft-primary rounded-pill" :class="{'bg-white':!$_utils.isEmpty(cardBg)}">
            <i class="mdi mdi-arrow-up-bold me-1" />{{ compared }} %
          </span>
        </template>
        <template v-else-if="compared < 0">
          <span class="badge badge-soft-danger rounded-pill" :class="{'bg-white':!$_utils.isEmpty(cardBg)}">
            <i class="mdi mdi-arrow-down-bold me-1" />{{ compared }} %
          </span>
        </template>
        <template v-else>
          <span class="badge badge-soft-secondary rounded-pill ct-padding-left-100 ct-padding-right-100" :class="{'bg-white':!$_utils.isEmpty(cardBg)}"
          >
            {{ compared }} %
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to';

export default {
  components: { countTo },
  props: {
    cardBg: String,
    iconImage: String,
    iconColor: {type: String, default: 'secondary'},
    title: String,
    valueTitle: String,
    endVal: {type: Number, default: 0},
    valueTime: String,
    compared: {type: Number, default: 0},
    cardClass: String
  },
  data() {
    return {

    }
  },
  // computed: {
  //   cardBgColor() {
  //     return 'bg-' + this.cardBg + '-gradient';
  //   }
  // }
}
</script>